import { configureStore } from "@reduxjs/toolkit";
import wallet from "./walletSlice";

const store = configureStore({
  reducer: { wallet },
});

export default store;
